<div
  class="nav-item layout-column align-center-center gap-24"

  (click)="handleClickItem()"
>
  <div
    class="nav-item--icon-container align-center-center"
    [class.internal-link]="item.internal"
  >
    <mat-icon class="nav-item--icon" *ngIf="item.icon">{{
      item.icon
    }}</mat-icon>
    <!-- <mat-icon class="nav-item--icon" *ngIf="item.iconSvg" [svgIcon]="item.iconSvg"></mat-icon> -->
  </div>
  <div class="nav-item--label">{{ ucFirst(item.label) }}</div>
</div>
